import { useState,useRef,useEffect } from 'react';
import styles from './Sidebar.module.css';
import Checkbox from '../../compoenets/Checkbox';
import ModelAdd from './ModelAdd';
import ModelUpload from './ModelUpload';
import ListSkeleton from '../../compoenets/ListSkeleton/ListSkeleton';
import useApi from '../../services/useApi';
import ConfirmModal from '../../compoenets/ConfirmModal';

const Item=({item,checkedModels,handleCheckChange,onChange,actionBtn=true})=>{
    const itemRef=useRef(null);
    const modelNameRef=useRef(null);
    const [isEdit,setIsEdit]=useState(false);
    const [isDelete,setIsDelete]=useState(false);
    const [isTooltip,setIsTooltip]=useState(false);
    const [tooltip,setTooltip]=useState({x:0,y:0});
    const inputRef=useRef(null);
    const [inputValue,setInputValue]=useState(item.modelName);

    const handleInputKeyDown=(e)=>{
        if(e.key ==='Escape'){
            setIsEdit(false);
        }
        else if(e.key==='Enter'){
            handleUpdateName(e);
        }
    }

    useEffect(()=>{
        if(!inputRef.current)return;
        inputRef.current.focus();

        const handleClickOutside=(e)=>{
            if(isEdit&&itemRef.current&&!itemRef.current.contains(e.target)){
                setIsEdit(false);
            }
        }


        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
    },[isEdit])

    const handleRemove=(e)=>{
        abortEvent(e)
        setIsDelete(true);
    }

    const handleEdit=(e)=>{
        abortEvent(e)
        setIsEdit(true);
    }

    const handleModelNameMove=(e)=>{
        const modelName = modelNameRef.current;
        if (!modelName) return;
    
        const isOverflowing = modelName.scrollWidth > modelName.clientWidth;
    
        if (isOverflowing) {
          setIsTooltip(true);
          setTooltip({
            x: e.clientX + 10,
            y: e.clientY + 10,
          });
        } else {
          setIsTooltip(false);
        }
    }

    const handleModelNameLeave=()=>{
        setIsTooltip(false);
    }

    const handleUpdateName=(e)=>{
        abortEvent(e);
        useApi.put('backboard/model/playground/'+item.modelId,{
            modelId:item.modelId,
            userId:JSON.parse(localStorage.getItem("account")).id,
            modelName:inputValue,
        }).then((res)=>{
            onChange();
        }).catch(function (thrown) {
        });
    }

    const abortEvent=(e)=>{
        e.preventDefault();
        e.stopPropagation();
    }

    return(
        <>
        <div ref={itemRef} className={`${styles['item']} ${isEdit&&styles['item-edit']}`} onClick={()=>handleCheckChange(item['modelId'])}>
            {!isEdit?<>
            <Checkbox 
            isChecked={checkedModels.includes(item['modelId'])}
            onChange={()=>handleCheckChange(item['modelId'])}
            />
            <span
            ref={modelNameRef}
            onMouseMove={(e)=>handleModelNameMove(e,item.modelName)}
            onMouseLeave={handleModelNameLeave}
            >{item['modelName']}</span>
            {actionBtn&&<div className={styles['item-action']}>
                <button onClick={handleEdit}/>
                <button onClick={handleRemove}/>
            </div>}
            </>:
            <>
            <input
            ref={inputRef}
            value={inputValue}
            onClick={abortEvent}
            onKeyDown={handleInputKeyDown}
            onChange={(e)=>setInputValue(e.target.value)}
            />
            {actionBtn&&<div className={styles['item-action']}>
                <button onClick={(e)=>{abortEvent(e);setIsEdit(false)}}/>
                <button onClick={handleUpdateName}/>
            </div>}
            </>
        }
        </div>
        {isDelete&&<ConfirmModal
        title='Model Delete'
        subTitle={'모델 '+item.modelName+'을 삭제하겠습니까?'}
        confirmText='Delete'
        onAction={()=>{
            useApi.delete('backboard/model/playground/'+item.modelId+'?userId='+JSON.parse(localStorage.getItem("account")).id).then((res)=>{
                setIsDelete(false);
                onChange();
            }).catch(function (thrown) {
            });
        }}
        onClose={()=>setIsDelete(false)}
        />}
        {isTooltip&&<div 
        className={styles['tooltip']}
        style={{top:tooltip.y,left:tooltip.x}}
        >
            {item.modelName}
        </div>}
        </>
    )

}

export default function Sidebar({
    isLoad,
    className,
    modelList,
    checkedModels,
    setCheckedModels,
    onChange,
}){
    const [isModelAdd,setIsModelAdd]=useState(false);
    const [isModelUpload,setIsModelUpload]=useState(false);

    const isAllChecked=checkedModels.length===modelList.length;
    const handleCheckChange=(itemId)=>{
        setCheckedModels(prev=>
            prev.includes(itemId)?
            prev.filter(id=>id!==itemId)
            :[...prev,itemId]
        )
    }

    const handleCheckAll=()=>{
        if(checkedModels.length===modelList.length){
            setCheckedModels([]);
        }else{
            setCheckedModels(modelList.map(item=>item.modelId));
        }
    }

    return(
        <nav className={`${className} ${styles['wrap']}`}>
            <section>
                <header>
                    <span>Model List</span>
                    <button onClick={handleCheckAll}>{isAllChecked?'Uncheck All':'Check All'}</button>
                </header>
                <div className={styles['list-body']}>
                    <button onClick={()=>setIsModelAdd(true)}>Add round model</button>
                    <button onClick={()=>setIsModelUpload(true)}>Upload local model</button>
                    <div className={styles['seperator']}>
                        <span>Personal Model</span>
                        <hr/>
                    </div>
                    {!isLoad&&<>
                    {modelList.map((item)=>
                        item.userId&&
                        <Item
                        item={item}
                        checkedModels={checkedModels}
                        handleCheckChange={handleCheckChange}
                        onChange={onChange}
                        />
                    )}
                    <div className={styles['seperator']}>
                        <span>Common Model</span>
                        <hr/>
                    </div>
                    {modelList.map((item)=>
                        !item.userId&&
                        <Item
                        item={item}
                        checkedModels={checkedModels}
                        handleCheckChange={handleCheckChange}
                        onChange={onChange}
                        actionBtn={false}
                        />
                    )}
                    </>}
                    {isLoad&&
                    <>
                        <ListSkeleton/>
                        <ListSkeleton/>
                        <ListSkeleton/>
                        <ListSkeleton/>
                        <ListSkeleton/>
                        <ListSkeleton/>
                        <ListSkeleton/>
                        <ListSkeleton/>
                    </>
                    }
                </div>
            </section>
            {isModelAdd&&<ModelAdd 
            onChange={onChange}
            onClose={()=>setIsModelAdd(false)}
            />}
            {isModelUpload&&<ModelUpload onClose={()=>setIsModelUpload(false)} onChange={onChange}/>}
            
        </nav>
    )
}